import React from 'react'
import { connect } from 'react-redux'
import Email from './Email'
import SMS from './SMS'

const FormContent = ({ selectedAction }) => {
  switch(selectedAction) {
    case 'email':
      return <Email />
    case 'sms':
      return <SMS />
    default:
      return null
  }
}

export default connect(
  state => ({
    selectedAction: state.tasks.addOrEdit.fields.selectedActionPrediction.value,
  }),
  null
)(FormContent)
